/**
 * QueryString utils module
 * @module: utils/queryString
 * @exports: queryStringParse
 */

/**
 * Create a hash map of query string key-value pairs.
 * @param {string} str - location.hash string to hash
 * @returns {object} hash map of query string key-value pairs
 * @author by Sindre Sorhus
 * @license MIT License
 * @see https://github.com/sindresorhus/query-string
 */
export function queryStringParse(str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#)/, '');
	str = str.indexOf('#') ? str.slice(str.indexOf('?') + 1) : str;

	if (!str) {
		return {};
	}

	return str.trim().split('&').reduce(function(ret, param) {
		let parts = param.replace(/\+/g, ' ').split( '=' );
		let key = parts[0];
		let val = parts[1];

		key = decodeURIComponent(key);
		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {} );
}



// WEBPACK FOOTER //
// ../~/dna-core/components/utils/js/queryString.js